var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "agent-tab" },
    [
      _c("div", { staticClass: "agent-tab-layout" }, [
        _c("div", { staticClass: "agent-settings-container" }, [
          _c("div", { staticClass: "agent-toolbar" }, [
            _c("div", { staticClass: "toolbar-left" }, [
              _c(
                "div",
                { staticClass: "model-selector" },
                [
                  _c("LLMConfiguration", {
                    attrs: { agent: _vm.agent },
                    on: { update: _vm.handleLLMConfigUpdate },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "voice-configuration" },
                [
                  _c("VoiceConfiguration", {
                    attrs: { agent: _vm.agent },
                    on: { update: _vm.handleVoiceConfigUpdate },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "language-selector" },
                [
                  _c("LanguagePicker", {
                    attrs: {
                      languages: _vm.languageOptions,
                      title: _vm.$t("voiceagent.selectLanguage"),
                      icon: "translate",
                    },
                    on: { change: _vm.handleLanguageChange },
                    model: {
                      value: _vm.agent.language,
                      callback: function ($$v) {
                        _vm.$set(_vm.agent, "language", $$v)
                      },
                      expression: "agent.language",
                    },
                  }),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "toolbar-right" },
              [
                _c(
                  "PermissionController",
                  { attrs: { permissions: ["voice-agent.update"] } },
                  [
                    _c(
                      "supsis-button",
                      { attrs: { primary: "" }, on: { click: _vm.saveAgent } },
                      [_vm._v(_vm._s(_vm.$t("voiceagent.save")))]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "prompt-editor-container" }, [
            _c(
              "div",
              { staticClass: "prompt-header" },
              [
                _c("div", { staticClass: "prompt-title" }, [
                  _c("h4", [
                    _vm._v(_vm._s(_vm.$t("voiceagent.voiceAgentPrompt"))),
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "prompt-subtitle" }, [
                    _vm._v(
                      _vm._s(_vm.$t("voiceagent.defineAgentBehaviorAndSpeech"))
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _vm.isSaving
                  ? _c("div", { staticClass: "prompt-status" }, [
                      _c("i", { staticClass: "material-icons spin" }, [
                        _vm._v("autorenew"),
                      ]),
                      _vm._v(
                        " " +
                          _vm._s(_vm.$t("voiceagent.saving")) +
                          "\n                    "
                      ),
                    ])
                  : _vm.agent.llm && _vm.promptSaved
                  ? _c("div", { staticClass: "prompt-status saved" }, [
                      _c("i", { staticClass: "material-icons" }, [
                        _vm._v("check_circle"),
                      ]),
                      _vm._v(
                        " " +
                          _vm._s(_vm.$t("voiceagent.saved")) +
                          "\n                    "
                      ),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "PermissionController",
                  { attrs: { permissions: ["voice-agent.update"] } },
                  [
                    _c(
                      "supsis-button",
                      {
                        attrs: { primary: "", loading: _vm.isSaving },
                        on: { click: _vm.savePrompt },
                      },
                      [
                        _c("i", { staticClass: "material-icons" }, [
                          _vm._v("save"),
                        ]),
                        _vm._v(
                          " " +
                            _vm._s(_vm.$t("voiceagent.saveChanges")) +
                            "\n                        "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "prompt-editor-wrapper" },
              [
                _vm.agent.llm
                  ? _c("a-textarea", {
                      ref: "promptEditor",
                      staticClass: "prompt-editor",
                      attrs: {
                        rows: 20,
                        placeholder: _vm.$t("voiceagent.writeAgentPromptHere"),
                      },
                      on: { input: _vm.handlePromptChange },
                      model: {
                        value: _vm.agent.llm.general_prompt,
                        callback: function ($$v) {
                          _vm.$set(_vm.agent.llm, "general_prompt", $$v)
                        },
                        expression: "agent.llm.general_prompt",
                      },
                    })
                  : _vm._e(),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "prompt-actions" },
              [
                _c(
                  "PermissionController",
                  { attrs: { permissions: ["voice-agent.update"] } },
                  [
                    _c(
                      "supsis-button",
                      {
                        attrs: { type: "default" },
                        on: { click: _vm.showVariableModal },
                      },
                      [
                        _c("i", { staticClass: "material-icons" }, [
                          _vm._v("add"),
                        ]),
                        _vm._v(
                          " " +
                            _vm._s(_vm.$t("voiceagent.addVariable")) +
                            "\n                        "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "welcome-message-selector" },
            [
              _c("h4", [_vm._v(_vm._s(_vm.$t("voiceagent.welcomeMessage")))]),
              _vm._v(" "),
              _c("CustomPicker", {
                attrs: {
                  items: _vm.welcomeMessageOptions,
                  idKey: "value",
                  labelKey: "title",
                  title: _vm.$t("voiceagent.selectWelcomeMessageType"),
                  icon: "message",
                },
                on: { input: _vm.handleWelcomeMessageChange },
                model: {
                  value: _vm.welcomeMessageType,
                  callback: function ($$v) {
                    _vm.welcomeMessageType = $$v
                  },
                  expression: "welcomeMessageType",
                },
              }),
              _vm._v(" "),
              _vm.welcomeMessageType === "ai_defined"
                ? _c(
                    "div",
                    { staticClass: "custom-welcome-message" },
                    [
                      _c("a-textarea", {
                        attrs: {
                          rows: 3,
                          placeholder: _vm.$t(
                            "voiceagent.enterCustomWelcomeMessage"
                          ),
                        },
                        model: {
                          value: _vm.customWelcomeMessage,
                          callback: function ($$v) {
                            _vm.customWelcomeMessage = $$v
                          },
                          expression: "customWelcomeMessage",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "agent-test-container" }, [
          _c("div", { staticClass: "test-panel" }, [
            _c("h3", [_vm._v(_vm._s(_vm.$t("voiceagent.agentTest")))]),
            _vm._v(" "),
            _c("div", { staticClass: "test-tabs" }, [
              _c(
                "div",
                {
                  staticClass: "test-tab",
                  class: { active: _vm.testTab === "call" },
                  on: {
                    click: function ($event) {
                      _vm.testTab = "call"
                    },
                  },
                },
                [
                  _c("i", { staticClass: "material-icons" }, [_vm._v("call")]),
                  _vm._v(
                    "\n                        " +
                      _vm._s(_vm.$t("voiceagent.callTest")) +
                      "\n                    "
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "test-tab",
                  class: { active: _vm.testTab === "chat" },
                  on: {
                    click: function ($event) {
                      _vm.testTab = "chat"
                    },
                  },
                },
                [
                  _c("i", { staticClass: "material-icons" }, [_vm._v("chat")]),
                  _vm._v(
                    "\n                        " +
                      _vm._s(_vm.$t("voiceagent.chatTest")) +
                      "\n                    "
                  ),
                ]
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "test-content" },
              [
                _vm.testTab === "call"
                  ? _c("RetellAudioTest", {
                      attrs: { agent: _vm.agent },
                      on: {
                        callStarted: _vm.handleCallStarted,
                        callEnded: _vm.handleCallEnded,
                      },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.testTab === "chat"
                  ? _c("RetellChatTest", {
                      attrs: { agent: _vm.agent },
                      on: {
                        chatStarted: _vm.handleChatStarted,
                        chatEnded: _vm.handleChatEnded,
                      },
                    })
                  : _vm._e(),
              ],
              1
            ),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("variable-selector", {
        attrs: { visible: _vm.variableModalVisible },
        on: {
          close: _vm.closeVariableModal,
          "insert-variable": _vm.insertVariable,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }